import { useMemo } from 'react';
import { useGetMachinesQuery } from '../../../gql/generated';
import { Input } from '../../Input';
import { MachineBadge } from '../../MachineBadge';
import { SearchableSelect } from '../../SearchableSelect';
import { useAddAlarmDialog } from './useAddAlarmDialog';

export function AlarmDetailsStep() {
  const { formData, updateFormData } = useAddAlarmDialog();

  // Fetch all machines for the searchable select
  const { data: allMachinesData, loading: allMachinesLoading } =
    useGetMachinesQuery({
      variables: {
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      fetchPolicy: 'cache-and-network',
    });

  const selectedMachines = useMemo(() => {
    const allMachines = allMachinesData?.machines.rows || [];
    return allMachines.filter((m) => formData.machines.includes(m.id));
  }, [allMachinesData, formData.machines]);

  return (
    <div className='flex flex-col gap-6 px-4 py-4 md:px-6'>
      {/* Alarm Name */}
      <div className='flex flex-col gap-1.5'>
        <label className='size-p2 text-primary' htmlFor='alarm-name'>
          Alert name
        </label>
        <Input
          id='alarm-name'
          placeholder='Name'
          value={formData.name}
          onChange={(e) => updateFormData({ name: e.target.value })}
          autoFocus
        />
      </div>

      {/* Machines */}
      <div className='flex flex-col gap-1.5'>
        <label className='size-p2 text-primary'>Machine display name</label>
        <SearchableSelect
          mode='multi'
          options={
            allMachinesData?.machines.rows.map((m) => ({
              value: m.id,
              label: m.displayName || m.machineId,
            })) || []
          }
          selectedValues={formData.machines}
          onSelectionChange={(values) => updateFormData({ machines: values })}
          placeholder={
            allMachinesLoading ? 'Loading machines...' : 'Select machines'
          }
          disabled={allMachinesLoading}
          label='Select Machines'
        />
        {selectedMachines.length > 0 && (
          <div className='flex flex-wrap items-center gap-1.5'>
            {selectedMachines.map((machine) => (
              <MachineBadge
                key={machine.id}
                name={machine.displayName || machine.machineId}
                removable
                onRemove={() => {
                  const updatedMachines = formData.machines.filter(
                    (id) => id !== machine.id
                  );
                  updateFormData({ machines: updatedMachines });
                }}
              />
            ))}
            <button
              type='button'
              onClick={() => updateFormData({ machines: [] })}
              className='size-caption text-focus hover:text-focus-hover
                cursor-pointer px-1 py-0.5'
            >
              Clear all
            </button>
          </div>
        )}
      </div>

    </div>
  );
}
